export default "__VITE_ASSET__sxLwbshT__"